import { render, staticRenderFns } from "./OfficialBbsList.vue?vue&type=template&id=4cf6b9ae&scoped=true"
import script from "./OfficialBbsList.vue?vue&type=script&lang=ts"
export * from "./OfficialBbsList.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./OfficialBbsList.vue?vue&type=style&index=0&id=4cf6b9ae&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4cf6b9ae",
  "2a406313"
  
)

export default component.exports